import CryptoJS from 'crypto-js';

export const aes = {
  // AES加密
  encrypt: (str, key = 'huijingsecretkey') => {
    try {
      const encrypted = CryptoJS.AES.encrypt(str, key);
      return encrypted.toString();
    } catch (e) {
      console.error('AES加密失败:', e);
      return str;
    }
  },
  // AES解密
  decrypt: (str, key = 'huijingsecretkey') => {
    try {
      const processedStr = decodeURIComponent(str.replace(/\s+/g, ''));
      const decrypted = CryptoJS.AES.decrypt(processedStr, key);
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (e) {
      console.error('AES解密失败:', e);
      return str;
    }
  }
};



// WEBPACK FOOTER //
// ./src/utils/crypto.js